import ChipLegalbird from "@/src/components/legalbird/ChipLegalbird/ChipLegalbird.tsx";
import Typography from "@mui/material/Typography";
import React from "react";
import { Divider, Grid } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import jobBenefitsStyle from "@/src/components/Jobs/jobBenefitsStyle";
import Container from "@/src/components/Container/Container";

const jobBenefits = [
  {
    title: "Home Office",
    content:
      "Heute im Büro, aber morgen lieber von Zuhause? Du weißt, wie und wo du deine beste Leistung abrufen kannst. Trotzdem ist es uns auch wichtig und macht uns viel Freude, dich im Büro persönlich zu sehen und kennen zu lernen.",
  },
  {
    title: "Flexible Arbeitszeiten",
    content:
      "Du möchtest morgens später anfangen oder deine Mittagspause verlängern? Kein Problem! Du kannst dir deinen Arbeitstag so strukturieren, dass Arbeit und Freizeit bestmöglich miteinander vereinbar sind.",
  },
  {
    title: "Rheinblick",
    content:
      "Wir bieten dir eine tolle Arbeitsatmosphäre in einem modernen Büro im Kranhaus mit phantastischem Blick auf den Rhein und sehr guter Erreichbarkeit mit öffentlichen Verkehrsmitteln.",
  },
  {
    title: "Gesund & Mobil",
    content:
      "Wir glauben daran, dass Mobilität Freiheit bedeutet und übernehmen daher das Deutschlandticket für dich. Außerdem ist es uns sehr wichtig, nicht nur geistig fit zu bleiben, sondern immer auch körperlich. Wir bezuschussen daher den Urban Sports Club und stellen frisches Obst als gesunden Snack bereit.",
  },
];

const JobBenefits = () => {
  return (
    <Container variant={"lg"}>
      <Container variant={"xs"} sx={{ textAlign: "center" }}>
        <ChipLegalbird label={"Benefits"} />
        <Typography variant={"h3"}>Was wir dir bieten</Typography>
        <Typography>Neben einem tollen Team und einer inspirierenden, spannenden Arbeit, gibt es noch viele weitere Benefits für dich.</Typography>
      </Container>

      <Grid container spacing={1} sx={{ padding: "1rem", marginBottom: "4rem" }}>
        {jobBenefits.map((benefit) => (
          <Grid size={{ xs: 12, sm: 6 }} key={benefit.title}>
            <Card sx={jobBenefitsStyle.card} elevation={0}>
              <CardContent>
                <Typography variant={"h6"} component={"h5"}>
                  {benefit.title}
                </Typography>
                <Divider sx={{ marginBottom: "1rem" }} />
                <Typography>{benefit.content}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default JobBenefits;
